import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import TipsterPage from './pages/TipsterPage';
import ResultsPage from './pages/ResultsPage';
import SubscribePage from './pages/SubscribePage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import AdminLogin from './pages/AdminLogin';
import AdminPanel from './pages/AdminPanel';
import PayGuide from './pages/PayGuide';
import TermsPage from './pages/TermsPage';
import PrivacyPage from './pages/PrivacyPage';
import ResponsibleGamblingPage from './pages/ResponsibleGamblingPage';
import { Toaster } from './components/ui/toaster';
import ScrollToTop from './components/ScrollToTop';
import { DataProvider } from './context/DataContext';

function App() {
  return (
    <div className="App">
      <DataProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/tipsters/:id" element={<TipsterPage />} />
            <Route path="/results" element={<ResultsPage />} />
            <Route path="/subscribe" element={<SubscribePage />} />
            <Route path="/subscribe/:tipster" element={<SubscribePage />} />
            <Route path="/subscribe/:tipster/:days" element={<SubscribePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/pay-guide/:kind" element={<PayGuide />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/responsible-gambling" element={<ResponsibleGamblingPage />} />
            <Route path="/admin" element={<AdminLogin />} />
            <Route path="/admin/panel" element={<AdminPanel />} />
          </Routes>
          <Toaster />
        </BrowserRouter>
      </DataProvider>
    </div>
  );
}

export default App;
